import React, { useState, useRef, useEffect } from "react";
import { useReactToPrint } from "react-to-print";
import { Col, Form, Row } from "react-bootstrap";
import { Divider } from "antd";
import DatePicker from "react-datepicker";
import Navbar from "../../../Components/Navbar/Navbar";
import {
  formatDateSeconds,
  numberWithCommas,
  selectDropdownStyle,
} from "../../../Helpers/Utils/Common";
import { UseGetRequest } from "../../../Helpers/Hooks/GetApiRequests";
import { CSVLink } from "react-csv";
import html2pdf from "html2pdf.js";
import Select from "react-select";
import toast from "react-hot-toast";
import Footer from "../../../Components/Footer/Footer";

function ZReading() {
  const pdfRef = useRef();
  const [inactive, setInactive] = useState(true);
  const [reports, setReports] = useState("");
  const [reportDetails, setReportDetails] = useState({});
  const [otherDiscounts, setOtherDiscounts] = useState([]);
  const [cashLedgers, setCashLedgers] = useState([]);
  const [creditLedgers, setCreditLedgers] = useState([]);
  const [mediaSummary, setMediaSummary] = useState({});
  const [filter, setFilter] = useState({
    date: new Date().toLocaleDateString("en-CA"),
    // date_to: new Date().toLocaleDateString("en-CA"),
    account_id: "",
    branch_id: null,
  });
  const [branchOptions, setBranchOptions] = useState([]);

  const [readyExport, setReadyExport] = useState(false);
  const [exportData, setExportData] = useState([]);

  const exportHeaders = [
    { label: "Current Sales", key: "gross_sales" },
    { label: "Tax Sales", key: "tax_sales" },
    { label: "Total Tax", key: "total_tax" },
    { label: "Net Sales", key: "net_sales" },
    { label: "Vat Exempt Sales", key: "vat_exempt_sales" },
    { label: "No. Transactions", key: "no_of_transactions" },
    { label: "Total Quantity", key: "total_qty" },
    { label: "Subtotal Discount", key: "subtotal_discount" },
    { label: "No. Discounted", key: "no_of_discounted" },
    { label: "S. Citizen Disc", key: "s_citizen_disc" },
    { label: "No. Senior Disc", key: "no_s_citizen_disc" },
    { label: "S. Citizen VAT Exempt", key: "s_citizen_vat_exempt" },
    { label: "PWD Disc", key: "pwd_disc" },
    { label: "No. PWD Disc", key: "no_pwd_disc" },
    { label: "PWD VAT Exempt", key: "pwd_vat_exempt" },
    { lable: "Other Disc", key: "other_discount_name" },
    { label: "Other Disc VAT Exempt", key: "other_discount_total_discount" },
    {
      label: "Expanded Value Added Tax (EVAT)",
      key: "expanded_value_added_tax",
    },
    {
      label: "No. Expanded Value Added Tax (EVAT)",
      key: "no_expanded_value_added_tax",
    },
    { label: "Total Cash Sales", key: "total_cash_sales" },
    { label: "No. Cash Sales", key: "no_cash_sales" },
    { label: "Total Credit", key: "total_credit" },
    { label: "No. Credit", key: "no_credit" },
    { label: "Total GC/Coupon", key: "total_gc_coupon" },
    { label: "No. GC/Coupon", key: "no_gc_coupon" },
    { label: "No. Customers", key: "no_customers" },
    { label: "Dine In", key: "dine_in" },
    { label: "Take Out", key: "take_out" },
    { label: "Dine In (# of items)", key: "dine_in_no_items" },
    { label: "Take Out(# of items)", key: "take_out_no_items" },
    { label: "Avg Sales/Tax", key: "avg_sales_trx" },
    { label: "Avg Sales/Customer", key: "avg_sales_customer" },
    { label: "Avg Cash Change", key: "avg_cash_change" },
    { label: "Cash Ledger - Cashier", key: "cash_ledger_cashier" },
    { label: "Cash Ledger - Sales", key: "cash_ledger_sales" },
    { label: "Credit Ledger - Cashier", key: "credit_ledger_cashier" },
    { label: "Credit Ledger - Sales", key: "credit_ledger_sales" },
    { label: "GC Coupon - name", key: "gc_coupon_name" },
    { label: "GC Coupon - total", key: "total_ledger_gc_coupon" },
    { label: "Media Summary - cash", key: "media_summary_cash" },
    { label: "Media Summary - credit", key: "media_summary_credit" },
    { label: "Media Summary - gc", key: "media_summary_gc" },
  ];

  const handlePrintReport = useReactToPrint({
    content: () => pdfRef.current,
    pageStyle: () => "@page { size: letter; margin: 7mm; }",
  });

  const fetchReport = async () => {
    // const response = await getZReading(filter.date_from, filter.date_to)
    if (filter.branch_id) {
      const response = await UseGetRequest("reports/zreading", filter);
      if (response.data) {
        setReports(response.data.data);
        setReportDetails(response.data.data.reports);
        setOtherDiscounts(response.data.data.reports.other_discount);
        setCashLedgers(response.data.data.cash_ledger.cash_ledgers);
        setCreditLedgers(response.data.data.credit_ledger.credit_ledgers);
        setMediaSummary(response.data.data.media_summary);

        const report = [response.data.data.reports];
        const cash_ledger =
          response.data.data.cash_ledger.cash_ledgers?.map((data) => ({
            cash_ledger_cashier: data.cashier,
            cash_ledger_sales: data.total_cash,
          })) || [];

        const credit_ledger =
          response.data.data.credit_ledger.credit_ledgers?.map((data) => ({
            credit_ledger_cashier: data.cashier,
            credit_ledger_sales: data.total_credit,
          })) || [];

        // Check if gc_coupon is defined in the response data
        const gc_coupon =
          response.data.data.gc_coupon?.gc_coupons?.map((data) => ({
            gc_coupon_name: data.gc_coupon_name,
            total_ledger_gc_coupon: data.total_gc_coupon,
          })) || [];

        report.push({
          media_summary_cash:
            "MEDIA SUM. TOTAL: " +
            response.data.data.media_summary.media_summary.cash,
          media_summary_credit:
            "MEDIA SUM. TOTAL: " +
            response.data.data.media_summary.media_summary.credit,
          media_summary_gc:
            "MEDIA SUM. TOTAL: " +
            response.data.data.media_summary.media_summary.gc,
          cash_ledger_sales:
            "TOTAL: " + response.data.data.cash_ledger.total_cash,
          credit_ledger_sales:
            "TOTAL: " + response.data.data.credit_ledger.total_credit,
          total_ledger_gc_coupon:
            "TOTAL: " + response.data.data.gc_coupon.total_gc_coupon,
        });

        setReadyExport(true);

        // Concatenate cash_ledger, credit_ledger, and gc_coupon arrays into the report array
        setExportData(report.concat(cash_ledger, credit_ledger, gc_coupon));
        handlePrintReport();
      }
    } else {
      toast.error("Please select branch");
    }
  };

  /** EXPORT */
  function handleToCSV() {
    if (readyExport) {
      return (
        <CSVLink
          filename={"ZReading.csv"}
          data={exportData}
          headers={exportHeaders}
        >
          <button className="custom-primary-btn">Export to CSV</button>
        </CSVLink>
      );
    }
  }

  const handleDownloadPDF = async () => {
    setTimeout(async () => {
      const element = pdfRef.current;
      const options = {
        filename: `Z-Reading Report.pdf`,
        pageOrientation: "portrait",
        html2canvas: { scale: 3, dpi: 600 },
      };

      await html2pdf().set(options).from(element).save();
      await new Promise((resolve) => setTimeout(resolve, 500));
    }, 500);
  };

  const handleFilter = (e) => {
    const { name, value } = e.target;
    var filtercopy = { ...filter };
    filtercopy[name] = value;
    setFilter(filtercopy);
  };

  useEffect(() => {
    async function fetchAllBranches() {
      setBranchOptions([]);
      const response = await UseGetRequest("branches/get_all_branch", {});
      if (response.data) {
        const temp = response.data.data.map((row) => {
          var info = {};
          info.label = row.name;
          info.value = row.id;
          return info;
        });
        setBranchOptions([{ label: "All", value: null }, ...temp]);
      }
    }

    fetchAllBranches();
  }, []);

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive);
          }}
          active={"REPORTS"}
        />
      </div>
      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        
        <Row className="mb-4">
          <Col xs={12} lg={8}>
              <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2"> ZReading </h1>
          </Col>
          <Col xs={12} lg={2} className="mt-1 mt-lg-0">
            <div className="PO-filters">
              <button className="button-tertiary w-100" onClick={handleDownloadPDF}>
                Download PDF
              </button>
            </div>
          </Col>
          <Col lg={2} className="mt-2 mt-lg-0">
              <div className="PO-filters">
                <button className="button-tertiary w-100" onClick={fetchReport}>
                  Print
                </button>
              </div>
          </Col>
          <Col xs={12} lg={2}>
              {handleToCSV()}
          </Col>
        </Row>
        <hr />
        <div className="mb-3" />
        <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
            Filter By:
        </span>
        <Row className="PO-filters flex flex-row mx-2 my-1">
          <Col xs={6} lg={2}>
            <DatePicker
              autoComplete="off"
              name="date_from"
              placeholderText={"Select Date"}
              onChange={handleFilter}
              value={filter.date}
              fixedHeight
              className="date-filter me-4 form-control py-3"
              showYearDropdown
              dateFormatCalendar="MMMM"
              yearDropdownItemNumber={20}
              scrollableYearDropdown
            />
          </Col>
          <Col xs={6} lg={2}>
            <Select
              className="dropsearch-filter"
              classNamePrefix="react-select"
              placeholder={"All Branches"}
              styles={selectDropdownStyle}
              options={branchOptions}
              onChange={(e) =>
                setFilter((prev) => ({ ...prev, branch_id: e.value }))
              }
            />
          </Col>
        </Row>
        <div className="mb-2" />
        <Row>
          <div className="pdf-content" ref={pdfRef}>
            <Row className="justify-content-center">
              <Col sm={8}>
                <div className="d-flex row justify-content-center mt-1">
                  <label className="d-flex row justify-content-center mb-1 ">
                    Paperworld
                  </label>
                </div>
                <div className="d-flex row justify-content-center mt-1">
                  <label className="d-flex row justify-content-center mb-1 ">
                    Temp Address
                  </label>
                </div>
                <div className="d-flex row justify-content-center mt-1">
                  <label className="d-flex row justify-content-center mb-1 ">
                    Issued: 00/00/0000
                  </label>
                </div>
              </Col>
            </Row>
            <Row className="mt-3">
              {/* <Col sm={1}></Col> */}
              <Col sm={8}>
                <label>Z Reading</label>
                <br />
                <label>Date: {formatDateSeconds(new Date())}</label>
              </Col>
              {/* <Col sm={2}></Col> */}
            </Row>
            <Row>
              <Divider dashed className="custom-dash mt-2" />
            </Row>
            <Row>
              <Col xs={10}>
                <label>Current Sales</label>
                <br />
                <label>Vat Sales</label>
                <br />
                <label>Vat Exempt Sales</label>
                <br />
                <label>Zero-Rated</label>
                <br />
                <label>No. Transaction</label>
                <br />
                <label>Total Quantity</label>
                <br />
                <label>Subtotal Discount</label>
                <br />
                <label>No. of Cancelled SI</label>
                <br />
                <label>Amount Cancelled SI</label>
                <br />
                <label>S.Citizen Disc</label>
                <br />
                <label>No Senior Disc</label>
                <br />
                <label>S. Citizen Vat Exempt</label>
                <br />
                <label>PWD Disc</label>
                <br />
                <label>No PWD Disc</label>
                <br />
                <label>PWD Vat Exempt</label>
                <br />
              </Col>
              <Col xs={2} className="align-right">
                <label>
                  {numberWithCommas(
                    reportDetails.gross_sales
                      ? parseFloat(reportDetails.gross_sales).toFixed(2)
                      : "0.00"
                  )}
                </label>
                <br />
                <label>
                  {numberWithCommas(
                    reportDetails.tax_sales
                      ? parseFloat(reportDetails.tax_sales).toFixed(2)
                      : "0.00"
                  )}
                </label>
                <br />
                <label>
                  {numberWithCommas(
                    reportDetails.vat_exempt_sales
                      ? parseFloat(reportDetails.vat_exempt_sales).toFixed(2)
                      : "0.00"
                  )}
                </label>
                <br />
                <label>
                  {numberWithCommas(
                    reportDetails.zero_rated
                      ? parseFloat(reportDetails.zero_rated).toFixed(2)
                      : "0.00"
                  )}
                </label>
                <br />
                <label>
                  {reportDetails.no_of_transactions
                    ? reportDetails.no_of_transactions
                    : "0"}
                </label>
                <br />
                <label>
                  {reportDetails.total_qty ? reportDetails.total_qty : "0.00"}
                </label>
                <br />
                <label>
                  {numberWithCommas(
                    reportDetails.subtotal_discount
                      ? parseFloat(reportDetails.subtotal_discount).toFixed(2)
                      : "0.00"
                  )}
                </label>
                <br />
                <label>
                  {reportDetails.no_of_cancelled_si
                    ? reportDetails.no_of_cancelled_si
                    : 0}
                </label>
                <br />
                <label>
                  {reportDetails.amount_cancelled
                    ? reportDetails.amount_cancelled
                    : 0}
                </label>
                <br />
                <label>
                  {numberWithCommas(
                    reportDetails.s_citizen_disc
                      ? parseFloat(reportDetails.s_citizen_disc).toFixed(2)
                      : "0.00"
                  )}
                </label>
                <br />
                <label>
                  {reportDetails.no_s_citizen_disc
                    ? reportDetails.no_s_citizen_disc
                    : 0}
                </label>
                <br />
                <label>
                  {numberWithCommas(
                    reportDetails.s_citizen_vat_exempt
                      ? parseFloat(reportDetails.s_citizen_vat_exempt).toFixed(
                          2
                        )
                      : "0.00"
                  )}
                </label>
                <br />
                <label>
                  {numberWithCommas(
                    reportDetails.pwd_disc
                      ? parseFloat(reportDetails.pwd_disc).toFixed(2)
                      : "0.00"
                  )}
                </label>
                <br />
                <label>
                  {reportDetails.no_pwd_disc ? reportDetails.no_pwd_disc : 0}
                </label>
                <br />
                <label>
                  {numberWithCommas(
                    reportDetails.pwd_vat_exempt
                      ? parseFloat(reportDetails.pwd_vat_exempt).toFixed(2)
                      : "0.00"
                  )}
                </label>
                <br />
              </Col>
            </Row>
            <Row>
              <Col sm={1}></Col>
              <Col sm={4}>
                {otherDiscounts.map((data) => (
                  <>
                    <label>{data.name.toUpperCase()} Disc</label>
                    <br />
                    <label>No. {data.name.toUpperCase()} Disc</label>
                  </>
                ))}
              </Col>
              <Col sm={4} className="align-right">
                {otherDiscounts.map((data) => (
                  <>
                    <label>
                      {parseFloat(
                        data.total_discount > 0 ? data.total_discount : 0.0
                      ).toFixed(2)}
                    </label>
                    <br />
                    <label>
                      {data.no_of_discount ? data.no_of_discount : 0}
                    </label>
                    <br />
                  </>
                ))}
              </Col>
              <Col sm={2}></Col>
            </Row>
            <Row>
              {/* <Col sm={1}></Col> */}
              <Col xs={10}>
                <label>Total Vat</label>
                <br />
                <label>No. Vat Sales</label>
                <br />
                <label>Total Cash Sales</label>
                <br />
                <label>Total Credit</label>
                <br />
                <label>Total GC/Coupon</label>
                <br />
                <label>No. GC/Coupon</label>
                <br />
              </Col>
              <Col xs={2} className="align-right">
                <label>
                  {numberWithCommas(
                    reportDetails.expanded_value_added_tax
                      ? parseFloat(
                          reportDetails.expanded_value_added_tax
                        ).toFixed(2)
                      : "0.00"
                  )}
                </label>
                <br />
                <label>
                  {numberWithCommas(
                    reportDetails.no_expanded_value_added_tax
                      ? parseFloat(
                          reportDetails.no_expanded_value_added_tax
                        ).toFixed(2)
                      : "0.00"
                  )}
                </label>
                <br />
                <label>
                  {numberWithCommas(
                    reportDetails.total_cash_sales
                      ? parseFloat(reportDetails.total_cash_sales).toFixed(2)
                      : "0.00"
                  )}
                </label>
                <br />
                <label>
                  {numberWithCommas(
                    reportDetails.total_credit
                      ? parseFloat(reportDetails.total_credit).toFixed(2)
                      : "0.00"
                  )}
                </label>
                <br />
                <label>
                  {numberWithCommas(
                    reportDetails.total_gc_coupon
                      ? parseFloat(reportDetails.total_gc_coupon).toFixed(2)
                      : "0.00"
                  )}{" "}
                </label>
                <br />
                <label>
                  {reportDetails.no_gc_coupon ? reportDetails.no_gc_coupon : 0}
                </label>
                <br />
              </Col>
            </Row>
            <Row>
              <Col xs={10}>
                <label>CASH LEDGER</label>
                <br />
              </Col>
            </Row>
            <Row className="ms-3">
              <Col xs={10}>
                {cashLedgers !== null &&
                  cashLedgers.map((data) => {
                    return (
                      <>
                        <label>
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Cash
                          Sales &nbsp; - &nbsp; {data.cashier}
                        </label>
                        <br />
                      </>
                    );
                  })}
              </Col>
              <Col xs={2} className="align-right">
                {cashLedgers !== null &&
                  cashLedgers.map((data) => {
                    return (
                      <>
                        <label>
                          {numberWithCommas(
                            parseFloat(
                              data.total_cash ? data.total_cash : 0
                            ).toFixed(2)
                          )}
                        </label>
                        <br />
                      </>
                    );
                  })}
              </Col>
            </Row>
            <Row>
              <Col xs={10}>
                <label>CREDIT LEDGER</label>
                <br />
              </Col>
            </Row>
            <Row className="ms-3">
              <Col xs={10}>
                {creditLedgers !== null &&
                  creditLedgers.map((data) => {
                    return (
                      <>
                        <label>
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Credit
                          Sales &nbsp; - &nbsp; {data.cashier}
                        </label>
                        <br />
                      </>
                    );
                  })}
              </Col>
              <Col xs={2} className="align-right">
                {creditLedgers !== null &&
                  creditLedgers.map((data) => {
                    return (
                      <>
                        <label>
                          {numberWithCommas(
                            parseFloat(
                              data.total_credit ? data.total_credit : 0
                            ).toFixed(2)
                          )}
                        </label>
                        <br />
                      </>
                    );
                  })}
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                <label>MEDIA SUMMARY</label>
                <Row className="ms-3">
                  {Array.isArray(mediaSummary.media_summary) ? (
                    mediaSummary.media_summary.map((data) => {
                      return (
                        <>
                          <Col xs={12} md={6} lg={4}>
                            <label> {data.cash}</label>
                          </Col>
                          <Col xs={12} md={6} lg={4}>
                            <label> {data.credit}</label>
                          </Col>
                        </>
                      );
                    })
                  ) : (
                    <>
                      {/* <Col sm={2}></Col> */}
                      <Col xs={12} md={6} lg={4}>
                        <label>Cash: &nbsp;&nbsp;&nbsp;0.00</label>
                      </Col>
                      <Col xs={12} md={6} lg={4}>
                        <label>Credit: &nbsp;&nbsp;&nbsp;0.00</label>
                      </Col>
                      {/* <Col sm={2}></Col> */}
                    </>
                  )}
                </Row>
              </Col>
              {/* <Col sm={2}></Col> */}
            </Row>
            <Row>
              <Col sm={12}>
                <Row>
                  <Col xs={10}>
                    <label>Beg. SI:</label>
                  </Col>
                  <Col xs={2} className="align-right">
                    <label>{reports.beg_si}</label>
                  </Col>
                </Row>
                <Row>
                  <Col xs={10}>
                    <label>Beg. SI:</label>
                  </Col>
                  <Col xs={2} className="align-right">
                    <label>{reports.end_si}</label>
                  </Col>
                </Row>
                <Row>
                  <Col xs={10}>
                    <label>Prev Total:</label>
                  </Col>
                  <Col xs={2} className="align-right">
                    <label>
                      {numberWithCommas(
                        reportDetails.prev_grand_accumulated_total
                          ? parseFloat(
                              reportDetails.prev_grand_accumulated_total
                            ).toFixed(2)
                          : "0.00"
                      )}
                    </label>
                  </Col>
                </Row>
                <Row>
                  <Col xs={10}>
                    <label>Current Sales:</label>
                  </Col>
                  <Col xs={2} className="align-right">
                    <label>
                      {numberWithCommas(
                        reportDetails.gross_sales
                          ? parseFloat(reportDetails.gross_sales).toFixed(2)
                          : "0.00"
                      )}
                    </label>
                  </Col>
                </Row>
                <Row>
                  <Col xs={10}>
                    <label>New Grand Total:</label>
                  </Col>
                  <Col xs={2} className="align-right">
                    <label>
                      {numberWithCommas(
                        parseFloat(
                          reportDetails.new_total
                            ? reportDetails.new_total
                            : "0.00"
                        ).toFixed(2)
                      )}
                    </label>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row>
              <Divider dashed className="custom-dash mt-2" />
            </Row>
            <Row>
              <Col xs={12}>
                <div className="d-flex row justify-content-center mt-1">
                  <label className="d-flex row justify-content-center ">
                    Paperworld
                  </label>
                </div>
                <div className="d-flex row justify-content-center mt-1">
                  <label className="d-flex row justify-content-center ">
                    Temp Address
                  </label>
                </div>
              </Col>
            </Row>
          </div>
        </Row>
      </div>
      <Footer/>
    </div>
  );
}

export default ZReading;
